export const normalizeChartData = (chart: any) => {
    if (!chart?.type || !chart?.data) return chart;

    const { type, data } = chart;

    // PIE CHART
    if (type === 'pie' && data.labels && data.values) {
        return {
            ...chart,
            data: {
                labels: data.labels,
                datasets: [
                    {
                        data: data.values,
                        backgroundColor: generateColors(data.values.length),
                    },
                ],
            },
            options: {
                responsive: true,
                plugins: {
                    legend: {
                        position: 'right',
                    },
                },
            },
        };
    }

    // BAR & LINE CHART
    if ((type === 'bar' || type === 'line') && data.labels && data.values) {
        return {
            ...chart,
            data: {
                labels: data.labels,
                datasets: [
                    {
                        label: chart.title || 'Dataset',
                        data: data.values,
                        backgroundColor: type === 'bar' ? '#60A5FA' : undefined,
                        borderColor: type === 'line' ? '#6366F1' : undefined,
                        fill: type === 'line',
                    },
                ],
            },
            options: {
                responsive: true,
                plugins: {
                    legend: {
                        display: false, // DISABLED LEGEND (DATASET)
                    },
                },
                scales: {
                    y: {
                        beginAtZero: true,
                    },
                },
            },
        };
    }

    return chart;
};

const generateColors = (count: number) => {
    const palette = [
        '#60A5FA', '#A496FF', '#34D399', '#FBBF24', '#F87171',
        '#6366F1', '#F472B6', '#10B981', '#F59E0B', '#3B82F6',
        '#EC4899', '#8B5CF6', '#4ADE80', '#E879F9', '#FB923C', '#06B6D4'
    ];
    return Array.from({ length: count }, (_, i) => palette[i % palette.length]);
};
